import {createAction} from '@reduxjs/toolkit'

export const setVeloCategoryFilter = createAction<string>('SET_VELO_CATEGORY_FILTER')
